import { User } from "./user";

export interface Participation {
    id: string;
    activityId: string;
    userId: string;
    status: ParticipationStatus;
    createdAt: string;
    updatedAt: string;
    user: User;
}

export enum ParticipationStatus {
    JOINED = 'JOINED',
    QUIT = 'QUIT',
    FINISHED = 'FINISHED',
}
